import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@spz/ui/components/select";
import type { FC } from "react";
import type { SelectCellProps } from "../types";

export const SelectCell: FC<SelectCellProps> = ({
  value,
  options,
  onChange,
  className,
  disabled,
}) => {
  return (
    <Select
      value={value?.toString()}
      onValueChange={onChange}
      disabled={disabled}
    >
      <SelectTrigger className={className}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value?.toString()}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
